import { createStyles, makeStyles, Theme } from '@material-ui/core';
import classNames from 'classnames';
import React from 'react';

import { FeedAnswerFragment } from '../../../../graphql/gen/types';
import { colorPalette, spacings, TextSizesEnum } from '../../../../theme';
import { LinesEllipsis } from '../../../shared/primitives/LinesEllipsis';
import { PlexTypography } from '../../../shared/primitives/PlexTypography';
import { ReadOnlyEditor } from '../../../shared/slate/ReadOnlyEditor';
import { plainTextPreview } from '../../common/plainTextPreview';

interface Props {
  className?: string;
  answer: FeedAnswerFragment;
  showAllLines: boolean;
}

export const AnswerView = React.memo(
  (props: Props): React.ReactElement => {
    const { answer, showAllLines, className } = props;
    const classes = useStyles(props);

    return (
      <div className={classNames(classes.root, className)}>
        <PlexTypography className={classes.contentText} size={TextSizesEnum.Normal}>
          {showAllLines ? (
            <ReadOnlyEditor value={answer.body} entities={{ expanded_link: answer.links, mention: answer.mentions }} />
          ) : (
            <LinesEllipsis text={plainTextPreview(answer.body, answer.mentions, answer.links)} maxLine={2} />
          )}
        </PlexTypography>
      </div>
    );
  }
);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      paddingLeft: spacings.normal,
      paddingRight: spacings.normal,
      paddingTop: spacings.small,
      paddingBottom: spacings.small,
    },
    contentText: ({ showAllLines }: Props) => ({
      color: colorPalette.dark._800,
      fontWeight: 500,
      wordBreak: 'break-word',
      whiteSpace: 'pre-wrap', // fixes bug where only ellipsis would show when text is too long
    }),
  })
);
